export const activeFlashSale = (
  startDateString: string,
  endDateString: string
) => {
  // 1. First, check if both date strings exist. If not, the sale can't be active.
  if (!startDateString || !endDateString) {
    return false;
  }

  // 2. Get the current time in milliseconds.
  const now = new Date().getTime();

  // 3. Convert the start and end date strings into Date objects,
  //    then get their time in milliseconds.
  const startTime = new Date(startDateString).getTime();
  const endTime = new Date(endDateString).getTime();

  // 4. Check if any of the dates are invalid after parsing.
  //    If a string is not a valid date, .getTime() returns NaN.
  if (isNaN(startTime) || isNaN(endTime)) {
    console.error('Invalid date format for start or end time.');
    return false;
  }

  // 5. Return true if the current time is between the start and end times (inclusive).
  return now >= startTime && now <= endTime;
};
